import { ChangeDetectionStrategy, Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DialogComponent } from '@vsolv/vectors-ui/dialog';
import { CLAIM_ITEM_CONTROLS_CONFIG } from '../../config/claim-item-controls.config';

export type ClaimItemNotePrompt = (typeof CLAIM_ITEM_CONTROLS_CONFIG.noteDialog)['cancelHold' | 'resolveEscalation'];

/** Asks for a note before cancelling a hold or resolving an escalation; the caller saves it. */
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-claim-item-note-dialog',
  templateUrl: './claim-item-note.dialog.html',
  standalone: false,
})
export class ClaimItemNoteDialog {
  readonly config = CLAIM_ITEM_CONTROLS_CONFIG;

  @ViewChild(DialogComponent) dialog?: DialogComponent;

  @Output() confirmed = new EventEmitter<string | null>();

  prompt: ClaimItemNotePrompt | null = null;
  note = new FormControl('');

  open(prompt: ClaimItemNotePrompt) {
    this.prompt = prompt;
    this.note.reset('');
    this.dialog?.open();
  }

  close() {
    this.dialog?.close();
  }

  canConfirm() {
    return !this.prompt?.required || !!this.note.value?.trim();
  }

  confirm() {
    if (!this.canConfirm()) return;

    this.confirmed.emit(this.note.value?.trim() || null);
    this.close();
  }
}
